export const REGEXS = {
    DIGITS: /[0-9]/
  }
  
  export const KEY_CODES = {
    BACKSPACE: 8,
    DELETE: 46,
    ARROW_LEFT: 37,
    ARROW_RIGHT: 39
  }